import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Worker, Viewer } from "@react-pdf-viewer/core";
import { highlightPlugin } from "@react-pdf-viewer/highlight";

import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";

const PdfView = ({ publicationId, highlightData }) => {
  const [pdfUrl, setPdfUrl] = useState("");
  const BASE_URL = process.env.REACT_APP_BASE_URL;

  const highlightPluginInstance = highlightPlugin({
    renderHighlights: (props) => {
      const currentPage = props.pageIndex + 1;
      const currentPageHighlights =
        highlightData.find((item) => item.page_number === currentPage)?.bboxes || [];

      return (
        <>
          {currentPageHighlights.map((bbox, idx) => {
            const [x1, y1, x2, y2] = bbox;
            const scale = props.scale || 1;

            return (
              <div
                key={idx}
                style={{
                  position: "absolute",
                  left: `${x1 * scale}px`,
                  top: `${y1 * scale}px`,
                  width: `${(x2 - x1) * scale}px`,
                  height: `${(y2 - y1) * scale}px`,
                  backgroundColor: "rgba(255, 255, 0, 0.5)",
                  borderRadius: "2px",
                  zIndex: 10,
                }}
              />
            );
          })}
        </>
      );
    },
    renderHighlightTarget: () => <></>,
    renderHighlightContent: () => <></>,
    onTextSelection: () => {},
  });

  useEffect(() => {
    const fetchFileDetails = async () => {
      const token = localStorage.getItem("authToken");
      try {
        const response = await fetch(`${BASE_URL}/getPublicationsWithFilesAndTasks?publicationId=${publicationId}`, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        const data = await response.json();
        const publication = data.find((pub) => pub.id === Number(publicationId));
        if (publication?.url) {
          setPdfUrl(publication.url);
        } else {
          console.error("Publication not found");
        }
      } catch (error) {
        console.error("Error fetching file:", error);
      }
    };

    fetchFileDetails();
  }, [publicationId, BASE_URL]);

  return (
    <div style={{ width: "55%", padding: "20px" }}>
      <div style={{ marginBottom: "10px" }}>
        <span style={styles.breadcrumbMain}>PubVision AI</span>
        <span style={styles.breadcrumbSeparator}> &gt; </span>
        <Link to="/uploadfile" style={styles.breadcrumbLink}>
          <span style={styles.breadcrumbItem}>Upload</span>
        </Link>
        <span style={styles.breadcrumbSeparator}> &gt; </span>
        <Link to="/GenerationsHistory" style={styles.breadcrumbLink}>
          <span style={styles.breadcrumbItem}>Pub History</span>
        </Link>
        <span style={styles.breadcrumbSeparator}> &gt; </span>
        <span style={styles.breadcrumbItem}>Chat</span>
      </div>

      <div style={{ height: "80vh", border: "1px solid #ccc" }}>
        {pdfUrl && (
          <Worker workerUrl={`https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js`}>
            <Viewer fileUrl={pdfUrl} plugins={[highlightPluginInstance]} />
          </Worker>
        )}
      </div>
    </div>
  );
};

const styles = {
  pdfContainer: {
    overflow: "hidden",
    width: "55%",
    padding: "20px",
    display: "flex",
    flexDirection: "column",
  },
  breadcrumb: {
    marginBottom: "10px",
    fontWeight: "bold",
    color: "#444",
  },
  pdfWrapper: {
    position: "relative",
    width: "100%",
    height: "70vh",
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
    overflow: "hidden",
    background: "#fff",
  },
  pdfIframe: {
    width: "100%",
    height: "100%",
  },
  highlightOverlay: {
    position: "absolute",
    top: 0,
    left: 0,
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    zIndex: 2,
  },
  highlightBox: {
    position: "absolute",
    backgroundColor: "rgba(255, 255, 0, 0.5)",
    borderRadius: "4px",
  },
  viewerWrapper: {
    height: "70vh",
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
    background: "#fff",
    overflow: "hidden",
  },
  breadcrumbMain: {
    fontWeight: "bold",
    color: "#000",
  },
  breadcrumbSeparator: {
    margin: "0 5px",
    color: "#888",
  },
  breadcrumbItem: {
    color: "#888",
  },
  breadcrumbLink: {
    textDecoration: "none",
    cursor: "pointer",
  },
};

export default PdfView;